import React from "react";

export const StatusBadge = ({ code = "O" }) => {
  const map = {
    O: { txt: "Open", cls: "border-amber-200 bg-amber-50 text-amber-700" },
    P: { txt: "In Progress", cls: "border-sky-200 bg-sky-50 text-sky-700" },
    C: { txt: "Closed", cls: "border-emerald-200 bg-emerald-50 text-emerald-700" },
  };
  const s = map[code] || map.O;
  return (
    <span className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-semibold ${s.cls}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {s.txt}
    </span>
  );
};

export const PriorityBadge = ({ value = "" }) => {
  const v = String(value || "").toLowerCase();
  const map = {
    low:    "border-sky-200 bg-sky-50 text-sky-700",
    medium: "border-amber-200 bg-amber-50 text-amber-700",
    high:   "border-rose-200 bg-rose-50 text-rose-700",
    urgent: "border-orange-200 bg-orange-50 text-orange-700",
  };
  const txtMap = { low: "Low", medium: "Medium", high: "High", urgent: "Urgent" };
  const cls = map[v] || map.medium;
  const txt = txtMap[v] || "Medium";
  return (
    <span className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-semibold ${cls}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {txt}
    </span>
  );
};
